import { render, staticRenderFns } from "./TabelaServicos.vue?vue&type=template&id=047b02c8&"
import script from "./TabelaServicos.vue?vue&type=script&lang=js&"
export * from "./TabelaServicos.vue?vue&type=script&lang=js&"
import style0 from "./TabelaServicos.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports